<template>
  <div>
    <div v-if="item" class="pt-2" :class="{ 'px-3': $vuetify.breakpoint.mdAndUp }">
      <Breadcrumbs
        :class="{ 'px-5 mt-2': $vuetify.breakpoint.smAndDown }"
        data="item.name"
        :headline="itemTitle"
        :link="[
          { text: 'Điểm danh bán trú', href: '../boarding-class-session' },
          { text: itemTitle, id: item.id },
        ]"
      />
      <v-card class="d-flex justify-space-between align-center my-4 pa-5 border" outlined :key="itemChangeKey">
        <v-row no-gutters>
          <v-col cols="12" md="2">
            <span> Buổi </span>
            <h4>{{ item.date | ddmm }}</h4>
          </v-col>
          <v-col cols="12" md="2">
            <span> Lớp bán trú </span>
            <h4>{{ item.boardingClassTitle || '' }}</h4>
          </v-col>
          <v-col cols="12" md="2">
            <div>Có mặt</div>
            <div class="font-weight-bold">{{ item.attendanceCount }} / {{ item.totalCount }}</div>
          </v-col>
          <v-col cols="12" md="2">
            <div>Trạng thái</div>
            <v-chip
              small
              class="white--text"
              v-if="item.status"
              :color="item.status | boardingClassSessionStatusColor"
              label
            >
              {{ item.status | boardingClassSessionStatusText }}
            </v-chip>
          </v-col>
        </v-row>
      </v-card>

      <DetailTabs class="mt-8" />
    </div>
    <h1 v-else-if="!$loading.active">Không tìm thấy buổi bán trú</h1>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import DetailTabs from './DetailTabs.vue'

export default {
  components: { Breadcrumbs, DetailTabs },
  data: () => ({ tab: 1 }),
  computed: {
    ...mapGetters('boardingClassSession', ['item', 'itemChangeKey']),
    itemTitle() {
      return this.$options.filters.ddmm(this.item.date) + ' - ' + this.item.boardingClassTitle
    },
  },
  methods: {
    ...mapActions('boardingClassSession', ['fetchOne']),
  },
  async created() {
    this.$loading.active = true
    await this.fetchOne(this.$route.params.id)
    this.$loading.active = false
  },
}
</script>
<style scoped>
.theme--light.v-tabs-items {
  background-color: transparent;
}
td {
  padding-top: 4px;
}
td:first-child {
  padding-right: 48px;
}
</style>
